import type {
  PDFConvertFunction,
  PDFMergeFunction,
  PDFPlotFunction,
  PDFRasterizeFunction,
  PDFSeparationFunction,
  PDFSplitFunction,
} from "@pdfking/renderer-api"

export const PDFConvert: PDFConvertFunction = async (input, resolution) => {
  const { PDFConvert } = await import("../utils/Proxy")
  return PDFConvert(input, resolution)
}

export const PDFPlot: PDFPlotFunction = async function* (page, partial) {
  const { PDFPlot } = await import("../utils/Proxy")
  yield* PDFPlot(page, partial)
}

export const PDFMerge: PDFMergeFunction = async function* (pages) {
  const { PDFMerge } = await import("../utils/Proxy")
  yield* PDFMerge(pages)
}

export const PDFRasterize: PDFRasterizeFunction = async function* (
  input,
  image_dpi,
  rangeFn
) {
  const { PDFRasterize } = await import("../utils/Proxy")
  yield* PDFRasterize(input, image_dpi, rangeFn)
}

export const PDFSeparation: PDFSeparationFunction = async function* (
  input,
  options,
  rangeFn
) {
  const { PDFSeparation } = await import("@pdfking/renderer-ghostscript")
  yield* PDFSeparation(input, options, rangeFn)
}

export const PDFSplit: PDFSplitFunction = async function* (input, rangeFn) {
  const { PDFSplit } = await import("../utils/Proxy")
  yield* PDFSplit(input, rangeFn)
}
